import { render, staticRenderFns } from "./DdTextArea.vue?vue&type=template&id=0ad90b88&scoped=true&"
import script from "./DdTextArea.vue?vue&type=script&lang=js&"
export * from "./DdTextArea.vue?vue&type=script&lang=js&"
import style0 from "./DdTextArea.vue?vue&type=style&index=0&id=0ad90b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad90b88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTextarea,VTooltip})
